import React, { useState } from "react"
import styled from "styled-components"
import Chevron from "./svgs/chevron"
import { Link } from "gatsby"
import PropTypes from "prop-types"

const Text = styled.div`
  color: #272d37;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.5px;
`

const Holder = styled(Link)`
  display: flex;
  text-decoration: none;
  justify-content: space-between;
  padding: 0 16px;
  cursor: pointer;
  svg {
    transition: all 0.2s;
    transform: rotate(${props => (props.$isOpen ? "-90deg" : "90deg")});
  }
  &:hover {
    ${props => props.to && "text-decoration: underline;"}
  }
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const SubLinksHolder = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow: hidden;
  transition:
    max-height 0.4s ease-in-out,
    margin 0.3s ease-in,
    padding 0.3s ease-out;

  margin-top: ${props => (props.$isOpen ? "16px" : "0px")};
  max-height: ${props => (props.$isOpen ? "1000px" : "0px")};
  border-bottom: ${props => (props.$isOpen ? "1px solid #ECEFF3" : "none")};
  padding-bottom: ${props => (props.$isOpen ? "24px" : "0px")};
`

const SubLink = styled(Link)`
  color: #272d37;

  padding: 0px 16px;
  display: block;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`
const SubLinkAll = styled(SubLink)`
  font-weight: 700;
`

const NavbarMenuSliderItem = ({ name, url, items }) => {
  const [isOpen, setIsOpen] = useState(false)
  const holderProps =
    items.length > 0
      ? {
          onClick: () => {
            setIsOpen(!isOpen)
          },
        }
      : { to: url }

  return (
    <Wrapper>
      <span {...holderProps}>
        <Holder {...holderProps} $isOpen={isOpen}>
          <Text>{name}</Text>
          <Chevron />
        </Holder>
      </span>
      {items.length > 0 && (
        <SubLinksHolder $isOpen={isOpen}>
          {items.map(item => (
            <SubLink key={item.name} to={item.url || item.uri}>
              {item.name}
            </SubLink>
          ))}
          <SubLinkAll to={url}>{`See all of ${name} >`}</SubLinkAll>
        </SubLinksHolder>
      )}
    </Wrapper>
  )
}

NavbarMenuSliderItem.propTypes = {
  url: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object),
  name: PropTypes.string,
}
export default NavbarMenuSliderItem
